import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row, Space, Typography } from 'antd';

const { Title } = Typography;

const AnnouncementsHeader = ({ title, onClick, buttonLabel, isAdmin }) => (
  <Row justify="space-between">
    <Col>
      <Space size="large">
        <Title level={3}>{title}</Title>
      </Space>
    </Col>
    <Col>
      {isAdmin && (
        <Button type="ghost" onClick={onClick}>
          {buttonLabel}
        </Button>
      )}
    </Col>
  </Row>
);

AnnouncementsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool,
};

export default AnnouncementsHeader;
